<template>
    <!-- Where shared Sebapoznanie results meet the position; text only, never a score -->
    <div v-if="matches.length || asks.length" class="flex flex-col gap-3 text-sm">
        <div v-if="matches.length">
            <h4 class="mb-1 font-semibold text-gray-900 dark:text-txt-headings">{{ headings.match }}</h4>
            <ul class="flex flex-col gap-1">
                <li v-for="point in matches" :key="point.text" class="!mb-0 gap-2 text-gray-700 dark:text-txt-body">
                    <span aria-hidden="true">✓</span>
                    <span>{{ point.text }}</span>
                </li>
            </ul>
        </div>

        <div v-if="asks.length">
            <h4 class="mb-1 font-semibold text-gray-900 dark:text-txt-headings">{{ headings.ask }}</h4>
            <ul class="flex flex-col gap-1">
                <li v-for="point in asks" :key="point.text" class="!mb-0 gap-2 text-gray-700 dark:text-txt-body">
                    <span aria-hidden="true">?</span>
                    <span>{{ point.text }}</span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { FitAudience, FitPoint } from '#shared/sebapoznanie/jobFit'

const props = defineProps<{
    points: FitPoint[]
    audience: FitAudience
}>()

const matches = computed(() => props.points.filter((point) => point.kind === 'match'))
const asks = computed(() => props.points.filter((point) => point.kind === 'ask'))

const headings = computed(() =>
    props.audience === 'company'
        ? { match: 'Kde sa zhoduje s pozíciou', ask: 'Na čo sa spýtať na pohovore' }
        : { match: 'Čo ti sedí', ask: 'Na čo sa priprav' }
)
</script>
